import React from 'react';
import { Flex } from '../Flex';
/**
 * Put any child element inside it, give it any width or/and height, it'll ensure the child is centered.
 * `Center` composes the `Flex` component setting default values for "alignItems" and "justifyContent".
 * By default, it renders a `div` element. You can use the `tag` prop to change the element render, just like `as` prop from styled-components.
 */
export const Center = React.forwardRef((props, ref) => (React.createElement(Flex, { ref: ref, alignItems: "center", justifyContent: "center", ...props })));
